/**
 * Business Controls → Booking Rules in the browser (lib/booking/bookingRules.js). Read once per page load and shared;
 * the code defaults until it arrives or if the read fails.
 */
import { useEffect, useState } from 'react'
import { supabasePublic } from '@lib/supabase'
import { BOOKING_RULE_KEYS, DEFAULT_BOOKING_RULES, bookingRulesFromSettings } from '@/lib/booking/bookingRules.js'

let pending = null

export function loadBookingRules() {
  if (!pending) {
    // Promise.resolve().then: a client that can't make the read becomes the defaults, never a crash on the page
    pending = Promise.resolve()
      .then(() => supabasePublic.from('system_settings').select('setting_key, setting_value').in('setting_key', BOOKING_RULE_KEYS))
      .then(({ data, error }) => {
        if (error) throw error
        return bookingRulesFromSettings(data || [])
      })
      .catch(err => {
        console.warn('[bookingRules] read failed, using the defaults:', err?.message || err)
        pending = null
        return DEFAULT_BOOKING_RULES
      })
  }
  return pending
}

/** { rules, loaded } */
export function useBookingRules() {
  const [state, setState] = useState({ rules: DEFAULT_BOOKING_RULES, loaded: false })
  useEffect(() => {
    let live = true
    loadBookingRules().then(rules => { if (live) setState({ rules, loaded: true }) })
    return () => { live = false }
  }, [])
  return state
}
